var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.609 290.615H50.3906C35.5289 290.615 23.4375 278.524 23.4375 263.662V121.853C23.4375 116.676 27.6346 112.478 32.8125 112.478C37.9904 112.478 42.1875 116.676 42.1875 121.853V263.662C42.1875 268.185 45.8672 271.865 50.3906 271.865H249.609C254.133 271.865 257.812 268.185 257.812 263.662V121.853C257.812 116.676 262.01 112.478 267.188 112.478C272.365 112.478 276.562 116.676 276.562 121.853V263.662C276.562 278.524 264.472 290.615 249.609 290.615Z",
    fill: "#223180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.625 154.663C288.225 154.663 285.827 153.748 283.996 151.917L167.401 35.3226C157.806 25.7273 142.194 25.7273 132.599 35.3226L16.0041 151.917C12.3432 155.579 6.40708 155.579 2.74614 151.917C-0.915381 148.256 -0.915381 142.32 2.74614 138.659L119.341 22.0641C136.246 5.15858 163.754 5.15858 180.659 22.0641L297.254 138.659C300.915 142.32 300.915 148.256 297.254 151.917C295.424 153.748 293.024 154.663 290.625 154.663Z",
    fill: "#223180"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 290.615H112.5C107.322 290.615 103.125 286.417 103.125 281.24V198.037C103.125 181.883 116.268 168.74 132.422 168.74H167.578C183.732 168.74 196.875 181.883 196.875 198.037V281.24C196.875 286.417 192.678 290.615 187.5 290.615ZM121.875 271.865H178.125V198.037C178.125 192.221 173.394 187.49 167.578 187.49H132.422C126.606 187.49 121.875 192.221 121.875 198.037V271.865Z",
    fill: "#223180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/DASHBOARD.361b255c6053417243e716a6919c3698.svg";
export { ForwardRef as ReactComponent };